/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_InternalInputs */

const en_admin_dashboard_internal = /** @type {(inputs: Admin_Dashboard_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal`)
};

const de_admin_dashboard_internal = /** @type {(inputs: Admin_Dashboard_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intern`)
};

const es_admin_dashboard_internal = /** @type {(inputs: Admin_Dashboard_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interna`)
};

const fr_admin_dashboard_internal = /** @type {(inputs: Admin_Dashboard_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne`)
};

const nl_admin_dashboard_internal = /** @type {(inputs: Admin_Dashboard_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intern`)
};

const pt_br2_admin_dashboard_internal = /** @type {(inputs: Admin_Dashboard_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interna`)
};

const ro_admin_dashboard_internal = /** @type {(inputs: Admin_Dashboard_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intern`)
};

/** @type {(inputs: Admin_Dashboard_InternalInputs) => LocalizedString} */
const it_admin_dashboard_internal = en_admin_dashboard_internal;

/** @type {(inputs: Admin_Dashboard_InternalInputs) => LocalizedString} */
const pl_admin_dashboard_internal = en_admin_dashboard_internal;

/** @type {(inputs: Admin_Dashboard_InternalInputs) => LocalizedString} */
const hu_admin_dashboard_internal = en_admin_dashboard_internal;

/**
* | output |
* | --- |
* | "Internal" |
*
* @param {Admin_Dashboard_InternalInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_internal = /** @type {((inputs?: Admin_Dashboard_InternalInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_InternalInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_internal(inputs)
	if (locale === "de") return de_admin_dashboard_internal(inputs)
	if (locale === "es") return es_admin_dashboard_internal(inputs)
	if (locale === "fr") return fr_admin_dashboard_internal(inputs)
	if (locale === "nl") return nl_admin_dashboard_internal(inputs)
	if (locale === "it") return it_admin_dashboard_internal(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_internal(inputs)
	if (locale === "pl") return pl_admin_dashboard_internal(inputs)
	if (locale === "hu") return hu_admin_dashboard_internal(inputs)
	return ro_admin_dashboard_internal(inputs)
});
export { admin_dashboard_internal as "admin.dashboard.internal" }